import React, { useEffect, useRef, useState } from "react";
import { BsEyeSlash } from "react-icons/bs";
import { GoPencil, GoPlus } from "react-icons/go";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { IoChevronDownSharp } from "react-icons/io5";
import apiRequests from "../../Component/axios/config/config";
import { AiOutlineEye } from "react-icons/ai";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import Loading from "../../Component/Loading/Loading";
import { Pencil, Camera, Lock } from "lucide-react";
import toast from "react-hot-toast";
import ChangePasswordModal from "../../Component/changePasswordModal/changePasswordModal";
import { MdKeyboardArrowDown } from "react-icons/md";
import { BsImage } from "react-icons/bs";
import MapLocationPicker from "../../Component/MapLocationPicker/MapLocationPicker";

export default function Seller() {
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [loadingPassword, setLoadingPassword] = useState(false);

  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const [openImmigration, setOpenImmigration] = useState(false);
  const [openTrType, setOpenTrType] = useState(false);
  const immigrationDocRef = useRef(null);
  const [immigrationStatus, setImmigrationStatus] = useState({});
  const [loadingStatus, setLoadingStatus] = useState(false);

  const [profile, setProfile] = useState({
    userName: "",
    email: "",
    address: "",
    mobile: "",
    immigrationStatus: "",
    trType: "",
    immigrationDocument: null,
    bankAccountNumber: "",
    expire: "",
  });

  const [isEmailVerified, setIsEmailVerified] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const profileRes = await apiRequests.get("/seller/v1/get-my-profile");
        if (profileRes.data.success) {
          const data = profileRes.data.data;
          const isTemporaryType = ["visitor", "student", "worker"].includes(
            data.immigrationStatus,
          );

          setProfile({
            userName: data.userName || "",
            email: data.email || "",
            address: data.address || "",
            mobile: data.mobile || "",

            immigrationStatus: isTemporaryType
              ? "temporary"
              : data.immigrationStatus || "",
            expire: data.expire ? data.expire.split("T")[0] : "",
            trType: isTemporaryType ? data.immigrationStatus : "",

            immigrationDocument: data.immigrationDocument || null,
            bankAccountNumber: data.bankAccountNumber || "",
          });
          setIsEmailVerified(data.isEmailVerified);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  function EditeProfile() {
    setLoadingEdit(true);

    const payload = {
      userName: profile.userName,
      email: profile.email,
      address: profile.address,
      mobile: profile.mobile,

      immigrationStatus:
        profile.immigrationStatus === "temporary"
          ? profile.trType
          : profile.immigrationStatus,
      expire: profile.expire,

      bankAccountNumber: profile.bankAccountNumber,
    };

    apiRequests
      .patch("/seller/v1/edit-seller-profile", payload)
      .then((res) => {
        toast.success("Profile updated successfully!");
      })
      .catch((err) => {
        console.error("Edit profile error:", err);

        toast.error(
          err?.response?.data?.en_message ||
            "Failed to update profile. Server error.",
        );
      })
      .finally(() => setLoadingEdit(false));
  }

  useEffect(() => {
    const fetchImmigrationStatus = async () => {
      setLoadingStatus(true);

      try {
        const res = await apiRequests.get("/seller/v1/get-ImmigrationStatus");

        setImmigrationStatus(res.data.data || {});
      } catch (err) {
        console.log(err);
        toast.error("Failed to load immigration status");
      } finally {
        setLoadingStatus(false);
      }
    };

    fetchImmigrationStatus();
  }, []);

  const trTypeList = Object.values(immigrationStatus.Temporary || {});

  const mainStatusList = [
    {
      key: "TEMPORARY",
      value: "temporary",
      label: "Temporary Resident",
    },

    ...Object.entries(immigrationStatus)
      .filter(([key]) => key !== "Temporary")
      .map(([, val]) => val),
  ];

  async function handleChangePassword(formData) {
    const { password, newPassword, confirmPassword } = formData;

    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match");
      return;
    }

    setLoadingPassword(true);
    try {
      await apiRequests.patch("/seller/v1/resetpassword-seller", {
        password,
        newPassword,
      });
      toast.success("Password updated successfully!");
      setOpenPasswordModal(false);
    } catch (err) {
      console.error("Change password error:", err);
      toast.error(
        err?.response?.data?.en_message || "Failed to update password",
      );
    } finally {
      setLoadingPassword(false);
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const statusesWithoutExpire = [
    "protected_person",
    "permanent_resident",
    "canadian_citizen",
  ];

  const selectedImmigrationStatus =
    profile.immigrationStatus === "temporary"
      ? profile.trType
      : profile.immigrationStatus;

  const shouldShowExpireDate =
    selectedImmigrationStatus &&
    !statusesWithoutExpire.includes(selectedImmigrationStatus);

  if (loading) {
    return (
      <div className="w-full h-64 flex items-center justify-center text-gray-500 font-medium">
        Loading profile...
      </div>
    );
  }
  return (
    <div className="w-full flex justify-center p-10 sm:p-4 text-[#5c4a40]">
      <div className="w-full max-w-7xl flex flex-col gap-12 sm:gap-6">
        <section className="grid grid-cols-3 gap-x-7 gap-y-8 w-full sm:grid-cols-1 sm:gap-x-0 sm:gap-y-6">
          <div className="flex flex-col gap-2">
            <label
              htmlFor="Name"
              className="font-medium text-lg opacity-80 ml-1 text-inputColor-labelColor"
            >
              Name:
            </label>
            <input
              type="text"
              name="userName"
              disabled={!isEditing}
              value={profile.userName}
              onChange={handleChange}
              className="bg-[#efe5df] h-14 rounded-2xl px-5 w-full outline-none text-gray-800"
            />
          </div>
          <div className="flex flex-col gap-2">
            <label
              htmlFor="Mobile"
              className="font-medium text-lg opacity-80 ml-1 text-inputColor-labelColor"
            >
              Mobile:
            </label>
            <input
              type="text"
              name="mobile"
              disabled={!isEditing}
              value={profile.mobile}
              onChange={handleChange}
              className="bg-[#efe5df] h-14 rounded-2xl px-5 w-full outline-none text-gray-800"
            />
          </div>

          {/* <div className="flex flex-col gap-2">
            <label
              htmlFor="password"
              className="font-medium text-lg opacity-80 ml-1 text-inputColor-labelColor"
            >
              password
            </label>
            <div className="relative w-full">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={profile.password}
                onChange={handleChange}
                placeholder="******"
                className="bg-[#efe5df] h-14 rounded-2xl px-5 w-full outline-none text-gray-800"
              />
              <button className="absolute right-4 top-1/2 -translate-y-1/2 text-xl opacity-60">
                <div onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? (
                    <AiOutlineEyeInvisible className="w-6 h-6 text-gray-500 " />
                  ) : (
                    <AiOutlineEye className="w-6 h-6 text-gray-500 " />
                  )}
                </div>
              </button>
            </div>
          </div> */}

          <div className="flex flex-col gap-2">
            <label
              htmlFor="email"
              className="font-medium text-lg opacity-80 ml-1 text-inputColor-labelColor"
            >
              Email
            </label>

            <input
              type="email"
              name="email"
              disabled={!isEditing}
              value={profile.email}
              onChange={handleChange}
              className="bg-[#efe5df] h-14 rounded-2xl px-5 w-full outline-none text-gray-800"
            />

            <div className="flex items-center justify-between px-1">
              <div className="flex items-center gap-2">
                <span
                  className={`w-2.5 h-2.5 rounded-full ${
                    isEmailVerified ? "bg-green-500" : "bg-orange-500"
                  }`}
                ></span>

                <span
                  className={`text-sm font-medium ${
                    isEmailVerified ? "text-green-600" : "text-orange-600"
                  }`}
                >
                  {isEmailVerified ? "Verified" : "Not verified"}
                </span>
              </div>

              {!isEmailVerified && (
                <button
                  type="button"
                  className="text-sm font-medium text-blue-600 hover:underline transition"
                >
                  Verify email
                </button>
              )}
            </div>
          </div>

          <div className="flex flex-col gap-2 col-span-2 sm:col-span-1">
            <label
              htmlFor="address"
              className="font-medium text-lg opacity-80 ml-1 text-inputColor-labelColor"
            >
              Address
            </label>
            <div className="relative w-full">
              <input
                type="text"
                name="address"
                disabled={!isEditing}
                value={profile.address}
                onChange={handleChange}
                className="bg-[#efe5df] h-14 rounded-2xl px-5 w-full outline-none text-gray-800"
              />
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label className="font-medium text-lg opacity-80 ml-1 text-inputColor-labelColor">
              Bank Account Number
            </label>
            <input
              type="text"
              inputMode="numeric"
              maxLength={16}
              disabled={!isEditing}
              value={profile.bankAccountNumber}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                setProfile({ ...profile, bankAccountNumber: value });
              }}
              className="bg-[#efe5df] h-14 rounded-2xl px-5 w-full outline-none text-gray-800"
            />
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex flex-col gap-2">
              <label className="font-medium text-lg opacity-80 ml-1 text-inputColor-labelColor">
                Immigration Status
              </label>

              <div className="relative w-full">
                <button
                  type="button"
                  disabled={!isEditing}
                  onClick={() => {
                    setOpenImmigration((prev) => !prev);
                    setOpenTrType(false);
                  }}
                  className="bg-[#efe5df] h-14 rounded-2xl px-5 w-full flex justify-between items-center text-gray-800 disabled:cursor-not-allowed"
                >
                  <span>
                    {loadingStatus
                      ? "Loading..."
                      : mainStatusList.find(
                          (opt) => opt.value === profile.immigrationStatus,
                        )?.label || "Select immigration status"}
                  </span>

                  <MdKeyboardArrowDown className="ml-2 h-5 text-gray-500" />
                </button>

                {openImmigration && isEditing && (
                  <ul className="absolute top-full mt-2 w-full bg-white border border-gray-300 rounded-2xl shadow-lg z-30">
                    {mainStatusList.map((option) => (
                      <li
                        key={option.key}
                        onClick={() => {
                          setProfile((prev) => ({
                            ...prev,
                            immigrationStatus: option.value,
                            trType:
                              option.value === "temporary" ? prev.trType : "",
                          }));

                          setOpenImmigration(false);
                          setOpenTrType(false);
                        }}
                        className="py-2 px-4 cursor-pointer text-neutral-700 hover:bg-gray-100 border-b border-gray-200 last:border-b-0"
                      >
                        {option.label}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>

            {/* TR Type */}
            {profile.immigrationStatus === "temporary" && (
              <div className="flex flex-col gap-2">
                <label className="font-medium text-lg opacity-80 ml-1 text-inputColor-labelColor">
                  TR Type
                </label>

                <div className="relative w-full">
                  <button
                    type="button"
                    disabled={!isEditing}
                    onClick={() => {
                      setOpenTrType((prev) => !prev);
                      setOpenImmigration(false);
                    }}
                    className="bg-[#efe5df] h-14 rounded-2xl px-5 w-full flex justify-between items-center text-gray-800 disabled:cursor-not-allowed"
                  >
                    <span>
                      {trTypeList.find((opt) => opt.value === profile.trType)
                        ?.label || "Select TR type"}
                    </span>

                    <MdKeyboardArrowDown className="ml-2 h-5 text-gray-500" />
                  </button>

                  {openTrType && isEditing && (
                    <ul className="absolute top-full mt-2 w-full bg-white border border-gray-300 rounded-2xl shadow-lg z-30">
                      {trTypeList.map((option) => (
                        <li
                          key={option.key}
                          onClick={() => {
                            setProfile((prev) => ({
                              ...prev,
                              trType: option.value,
                              expire: "",
                            }));

                            setOpenTrType(false);
                          }}
                          className="py-2 px-4 cursor-pointer text-neutral-700 hover:bg-gray-100 border-b border-gray-200 last:border-b-0"
                        >
                          {option.label}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            )}
          </div>

          {shouldShowExpireDate && (
            <div className="flex flex-col gap-2">
              <label className="font-medium text-lg opacity-80 ml-1 text-inputColor-labelColor">
                Expire Date
              </label>

              <input
                type="date"
                name="expire"
                disabled={!isEditing}
                value={profile.expire}
                onChange={handleChange}
                className="bg-[#efe5df] h-14 rounded-2xl px-5 w-full outline-none text-gray-800"
              />
            </div>
          )}

          <div className="flex flex-col gap-2 col-span-1 ">
            <label className="font-medium text-lg opacity-80 ml-1 text-inputColor-labelColor">
              Immigration Document
            </label>
            <div
              onClick={() => isEditing && immigrationDocRef.current.click()}
              className={`w-full h-32 rounded-2xl border-2 border-dashed border-neutral-400 flex flex-col items-center justify-center text-neutral-400 ${
                isEditing ? "cursor-pointer" : "cursor-not-allowed opacity-70"
              }`}
            >
              <BsImage className="text-3xl mb-2" />
              <span>
                {profile.immigrationDocument
                  ? profile.immigrationDocument.name || "Document uploaded"
                  : "Upload immigration document"}
              </span>
              <input
                ref={immigrationDocRef}
                type="file"
                className="hidden"
                onChange={(e) =>
                  setProfile({
                    ...profile,
                    immigrationDocument: e.target.files[0],
                  })
                }
              />
            </div>
          </div>
        </section>

        {/* <section className="flex flex-col md:flex-row items-start md:items-center gap-4">
          <span className="font-medium text-xl opacity-80 mr-2 text-inputColor-labelColor">
            Categories:
          </span>

          <div className="flex flex-wrap gap-3 items-center">
            {profile.category.length > 0 ? (
              profile.category.map((catId) => {
                const cat = availableCategories.find((c) => c._id === catId);

                return (
                  <div
                    key={catId}
                    className="bg-[#efe5df] px-4 py-2 rounded-xl flex items-center gap-2"
                  >
                    <span>{cat?.name}</span>

                    <button
                      type="button"
                      onClick={() => {
                        setProfile((prev) => ({
                          ...prev,
                          category: prev.category.filter((id) => id !== catId),
                        }));
                      }}
                      className="text-xl opacity-60 hover:text-red-500"
                    >
                      <IoIosCloseCircleOutline />
                    </button>
                  </div>
                );
              })
            ) : (
              <span className="text-sm opacity-50">No categories</span>
            )}

            <div className="relative">
              <button
                onClick={() => setShowDropdown(!showDropdown)}
                className="border border-[#5c4a40] opacity-80 px-4 py-2 rounded-xl flex items-center gap-2 hover:bg-gray-50 bg-white"
              >
                <GoPlus className="text-xl" />
                <span>Add category</span>
              </button>

              {showDropdown && (
                <div className="absolute top-full left-0 mt-3 w-56 max-h-60 overflow-y-auto bg-white border border-[#efe5df] shadow-xl rounded-xl p-3 z-10 flex flex-col gap-2">
                  <input
                    placeholder="search categories"
                    className="bg-[#efe5df] rounded px-3 py-1 text-sm outline-none placeholder-[#5c4a40]/50"
                  />
                  <div className="flex flex-col text-sm opacity-80">
                    {availableCategories.map((c) => {
                      const isSelected = profile.category.includes(c._id);

                      return (
                        <span
                          key={c._id}
                          onClick={() => {
                            setProfile((prev) => {
                              if (prev.category.includes(c._id)) return prev;

                              return {
                                ...prev,
                                category: [...prev.category, c._id],
                              };
                            });
                          }}
                          className={`p-2 rounded cursor-pointer
        ${isSelected ? "bg-[#efe5df] opacity-50" : "hover:bg-[#efe5df]"}`}
                        >
                          {c.name}
                        </span>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </section> */}
        <div className="flex justify-between items-center mb-8 sm:flex-col sm:gap-4 sm:items-stretch">
          <button
            onClick={() => setOpenPasswordModal(true)}
            className="flex items-center justify-center gap-2 rounded-2xl bg-[#efe5df] px-4 py-3 text-sm font-medium text-[#051F33] transition-all duration-200 hover:bg-[#051F33] hover:text-white"
          >
            <Lock className="h-4 w-4" />
            Change Password
          </button>
          <button
            onClick={() => {
              if (isEditing) {
                EditeProfile();
                setIsEditing(false);
              } else {
                setIsEditing(true);
              }
            }}
            className="bg-[#051F33] flex items-center justify-center gap-2 text-white px-5 py-2 rounded-2xl font-medium hover:bg-[#082a45] transition shadow-sm"
          >
            {loadingEdit ? (
              <Loading textColor={"white-0"} />
            ) : (
              <>
                <Pencil className="w-4 h-4" />
                {isEditing ? "Confirm Edit" : "Edit Profile"}
              </>
            )}
          </button>
        </div>
      </div>
      <ChangePasswordModal
        open={openPasswordModal}
        onClose={() => setOpenPasswordModal(false)}
        onSubmit={handleChangePassword}
        loading={loadingPassword}
      />
    </div>
  );
}
